module.exports = __webpack_public_path__ + "img/xuda.96210f1b.jpg";